/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs */

const en__field__enum_primarystudyinterest_study_religious_studies23 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religious Studies`)
};

const de__field__enum_primarystudyinterest_study_religious_studies23 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religionswissenschaft`)
};

/**
* | output |
* | --- |
* | "Religious Studies" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_religious_studies23 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Religious_Studies23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_religious_studies23(inputs)
	return de__field__enum_primarystudyinterest_study_religious_studies23(inputs)
});
export { _field__enum_primarystudyinterest_study_religious_studies23 as "_field__enum_primaryStudyInterest_STUDY_RELIGIOUS_STUDIES" }